/** Problem Library — read-only operational validation UI (Epic 5 + v1.1). */

export const FACULTY_PROBLEM_LIBRARY_PATH = '/faculty/problem-library';
export const ADMIN_PROBLEM_LIBRARY_PATH = '/admin/problem-library';
export const FACULTY_PROBLEM_LIBRARY_ANALYTICS_PATH = '/faculty/problem-library/analytics';
export const ADMIN_PROBLEM_LIBRARY_ANALYTICS_PATH = '/admin/problem-library/analytics';

/** Assignment Intelligence v1.1 usage kinds — mirrors backend USAGE_KINDS. */
export const PROBLEM_USAGE_KINDS = [
  { value: 'most_assigned', label: 'Most assigned' },
  { value: 'least_assigned', label: 'Least assigned' },
  { value: 'never_reused', label: 'Never reused' },
  { value: 'frequently_reused', label: 'Frequently reused' },
  { value: 'recently_introduced', label: 'Recently introduced' },
  { value: 'recently_reused', label: 'Recently reused' },
];

/**
 * @param {'faculty'|'admin'} [rolePrefix]
 */
export function problemLibraryAnalyticsPath(rolePrefix) {
  return rolePrefix === 'admin'
    ? ADMIN_PROBLEM_LIBRARY_ANALYTICS_PATH
    : FACULTY_PROBLEM_LIBRARY_ANALYTICS_PATH;
}

/**
 * @param {'faculty'|'admin'} [rolePrefix]
 * @param {string} referenceKey
 */
export function problemLibraryDetailPath(rolePrefix, referenceKey) {
  const base =
    rolePrefix === 'admin' ? ADMIN_PROBLEM_LIBRARY_PATH : FACULTY_PROBLEM_LIBRARY_PATH;
  return `${base}/${encodeURIComponent(referenceKey)}`;
}

/**
 * @param {string} pathname
 * @returns {'faculty'|'admin'}
 */
export function problemLibraryRoleFromPath(pathname) {
  return String(pathname || '').startsWith('/admin') ? 'admin' : 'faculty';
}

/**
 * @param {string} pathname
 */
export function problemLibraryListPathFromLocation(pathname) {
  return problemLibraryRoleFromPath(pathname) === 'admin'
    ? ADMIN_PROBLEM_LIBRARY_PATH
    : FACULTY_PROBLEM_LIBRARY_PATH;
}
